import { useQuery } from "react-query";
import WorkTimeScreen from "..";
import Context from "../../../context";
import api from "../../../api";
import values from "../../../values";
import { useContext, useState } from "react";
import { TModal } from "../../../types/common.type";
import utils from "../../../utils";
import {
  ICreateAndUpdateWorkTime,
  IRequestWorkTime,
} from "../../../types/workTime.interface";

const CompanyContainer = () => {
  const [showModal, setShowModal] = useState<TModal>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedWorkTime, setSelectedWorkTime] =
    useState<ICreateAndUpdateWorkTime>();
  const [requestWorkTime, setRequestWorkTime] = useState<IRequestWorkTime>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
  });
  const { userInfo } = useContext(Context.AppContext);

  const resultWorkTime = useQuery(
    [values.useQueryKeys.getAllWorkTime, requestWorkTime],
    () =>
      api.getMethod.company.findWorkTime({
        ...requestWorkTime,
      })
  );

  const allArea = useQuery(
    [values.useQueryKeys.getAllArea, userInfo?.data?.result?._id],
    () =>
      api.getMethod.common.findArea({ company: userInfo?.data?.result?._id })
  );

  const updateWorkTime = async (WorkTime: ICreateAndUpdateWorkTime) => {
    setLoading(true);
    const result = await api.putMethod.company.updateWorkTime(WorkTime);
    if (result) {
      resultWorkTime.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      return false;
    }
  };
  const createWorkTime = async (WorkTimeInfo: ICreateAndUpdateWorkTime) => {
    console.log(WorkTimeInfo);
    setLoading(true);
    const result = await api.postMethod.company.createWorkTime(WorkTimeInfo);
    if (result) {
      resultWorkTime.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };
  const removeWorkTime = async (_id: string) => {
    setLoading(true);
    const result = await api.deleteMethod.company.deleteWorkTime(_id);
    if (result) {
      resultWorkTime.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };

  return (
    <Context.WorkTimeScreen.Provider
      value={{
        resultWorkTime,
        requestWorkTime,
        setRequestWorkTime,
        showModal,
        setShowModal,
        selectedWorkTime,
        setSelectedWorkTime,
        loading,
        setLoading,
        updateWorkTime,
        createWorkTime,
        removeWorkTime,
        allArea,
      }}
    >
      <WorkTimeScreen />
    </Context.WorkTimeScreen.Provider>
  );
};

export default CompanyContainer;
